import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import PWAInstallButton from './PWAInstallButton'

export default function Navigation() {
  const navigate = useNavigate()
  const { user, setUser } = useAuth()

  const handleLogout = () => {
    localStorage.removeItem('token')
    setUser(null)
    navigate('/')
  }

  return (
    <nav className="app-nav">
      <div className="nav-shell">
        <Link to="/" className="brand-mark">🧮 Math.Kids 3D</Link>
        <div className="nav-links">
          <Link to="/">Início</Link>
          <Link to="/atividades">Atividades</Link>
          <Link to="/estudio">Estúdio BNCC</Link>
          <Link to="/planos">Planos</Link>
          <Link to="/profissionais">Profissionais</Link>
          <Link to="/atendimento-online">Atendimento Online</Link>
          <Link to="/suporte">Chat</Link>
          <Link to="/faq">FAQ</Link>
          <PWAInstallButton />
          {user ? (
            <>
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/perfil">Perfil</Link>
              {user.userType === 'admin' ? <>
                <Link className="nav-accent" to="/admin/financeiro">Admin Financeiro</Link>
                <Link className="nav-accent" to="/admin/operacoes">Admin Operações</Link>
              </> : null}
              <button className="btn btn-danger" onClick={handleLogout}>Sair</button>
            </>
          ) : (
            <>
              <Link to="/login">Login</Link>
              <Link to="/registrar" className="btn btn-primary">Registrar</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  )
}
